import _defineProperty from "/workdir/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";

var _renderMark, _renderNode;

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { Children, cloneElement, isValidElement } from 'react';
import { documentToReactComponents } from '@contentful/rich-text-react-renderer';
import { BLOCKS, INLINES, MARKS } from '@contentful/rich-text-types';
import Divider from '@segment/matcha/components/Divider';
import Code from '@segment/matcha/components/Code';
import Highlighter from '@segment/matcha/components/Highlighter';
import ContentDownloadForm from '@segment/templates/Forms/ContentDownloadForm';
import contentfulImageLoader from '@segment/utils/contentfulImageLoader';
import Blockquote from './Blockquote';
import CodeBlock from './CodeBlock';
import ColoredTypography from './ColoredTypography';
import Figure from './Figure';
import List, { ListItem } from './List';
import Table from './Table';
import Video from './Video';
import * as views from './RichText.views';
import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { Fragment as _Fragment } from "@emotion/react/jsx-runtime";
export var defaultOptions = {
  renderMark: (_renderMark = {}, _defineProperty(_renderMark, MARKS.CODE, function (text) {
    return _jsx(Code, {
      children: text
    });
  }), _defineProperty(_renderMark, MARKS.BOLD, function (text) {
    return _jsx(views.Bold, {
      children: text
    });
  }), _renderMark),
  renderNode: (_renderNode = {}, _defineProperty(_renderNode, BLOCKS.HEADING_1, function (_, children) {
    return _jsx(ColoredTypography, {
      variant: "h1",
      children: children
    });
  }), _defineProperty(_renderNode, BLOCKS.HEADING_2, function (_, children) {
    return _jsx(ColoredTypography, {
      variant: "h2",
      children: children
    });
  }), _defineProperty(_renderNode, BLOCKS.HEADING_3, function (_, children) {
    return _jsx(ColoredTypography, {
      variant: "h3",
      children: children
    });
  }), _defineProperty(_renderNode, BLOCKS.HEADING_4, function (_, children) {
    return _jsx(ColoredTypography, {
      variant: "h4",
      children: children
    });
  }), _defineProperty(_renderNode, BLOCKS.HEADING_5, function (_, children) {
    return _jsx(ColoredTypography, {
      variant: "h5",
      children: children
    });
  }), _defineProperty(_renderNode, BLOCKS.HEADING_6, function (_, children) {
    return _jsx(ColoredTypography, {
      variant: "h6",
      children: children
    });
  }), _defineProperty(_renderNode, BLOCKS.PARAGRAPH, function (_, children) {
    return _jsx(ColoredTypography, {
      variant: "pLarge",
      tag: "p",
      children: children
    });
  }), _defineProperty(_renderNode, BLOCKS.UL_LIST, function (_, children) {
    return _jsx(List, {
      children: children
    });
  }), _defineProperty(_renderNode, BLOCKS.OL_LIST, function (_, children) {
    return _jsx(List, {
      tag: "ol",
      children: children
    });
  }), _defineProperty(_renderNode, BLOCKS.LIST_ITEM, function (_, children) {
    return _jsx(ListItem, {
      children: Children.map(children, function (child) {
        if ( /*#__PURE__*/isValidElement(child)) {
          return /*#__PURE__*/cloneElement(child, _objectSpread(_objectSpread({}, child.props), {}, {
            variant: "pMedium"
          }));
        }
      })
    });
  }), _defineProperty(_renderNode, INLINES.HYPERLINK, function (node, children) {
    return _jsx("a", {
      target: node.data.target || "_self",
      href: node.data.uri,
      "data-dynamic-link": "true",
      children: children
    });
  }), _defineProperty(_renderNode, BLOCKS.EMBEDDED_ASSET, function (node) {
    var _node$data$target$fie = node.data.target.fields,
        file = _node$data$target$fie.file,
        title = _node$data$target$fie.title,
        description = _node$data$target$fie.description;
    return _jsx(Figure, {
      src: file.url,
      width: file.details.image.width,
      height: file.details.image.height,
      title: title,
      loader: contentfulImageLoader,
      caption: description
    });
  }), _defineProperty(_renderNode, BLOCKS.EMBEDDED_RESOURCE, function (node) {
    var _node$data, _node$data$target, _node$data$target$sys, _node$data$target$sys2, _node$data$target$sys3;

    var blockId = node === null || node === void 0 ? void 0 : (_node$data = node.data) === null || _node$data === void 0 ? void 0 : (_node$data$target = _node$data.target) === null || _node$data$target === void 0 ? void 0 : (_node$data$target$sys = _node$data$target.sys) === null || _node$data$target$sys === void 0 ? void 0 : (_node$data$target$sys2 = _node$data$target$sys.contentType) === null || _node$data$target$sys2 === void 0 ? void 0 : (_node$data$target$sys3 = _node$data$target$sys2.sys) === null || _node$data$target$sys3 === void 0 ? void 0 : _node$data$target$sys3.id;

    if (blockId === "downloadOnSubmitForm") {
      var _node$data2, _node$data2$target, _node$data2$target$fi, _node$data3, _node$data3$target, _node$data3$target$fi, _node$data4, _node$data4$target, _node$data4$target$fi, _node$data4$target$fi2, _node$data4$target$fi3, _node$data4$target$fi4, _node$data5, _node$data5$target, _node$data5$target$fi, _node$data6, _node$data6$target, _node$data6$target$fi;

      return _jsx(ContentDownloadForm, {
        heading: node === null || node === void 0 ? void 0 : (_node$data2 = node.data) === null || _node$data2 === void 0 ? void 0 : (_node$data2$target = _node$data2.target) === null || _node$data2$target === void 0 ? void 0 : (_node$data2$target$fi = _node$data2$target.fields) === null || _node$data2$target$fi === void 0 ? void 0 : _node$data2$target$fi.header,
        description: node === null || node === void 0 ? void 0 : (_node$data3 = node.data) === null || _node$data3 === void 0 ? void 0 : (_node$data3$target = _node$data3.target) === null || _node$data3$target === void 0 ? void 0 : (_node$data3$target$fi = _node$data3$target.fields) === null || _node$data3$target$fi === void 0 ? void 0 : _node$data3$target$fi.description,
        image: node === null || node === void 0 ? void 0 : (_node$data4 = node.data) === null || _node$data4 === void 0 ? void 0 : (_node$data4$target = _node$data4.target) === null || _node$data4$target === void 0 ? void 0 : (_node$data4$target$fi = _node$data4$target.fields) === null || _node$data4$target$fi === void 0 ? void 0 : (_node$data4$target$fi2 = _node$data4$target$fi.image) === null || _node$data4$target$fi2 === void 0 ? void 0 : (_node$data4$target$fi3 = _node$data4$target$fi2.fields) === null || _node$data4$target$fi3 === void 0 ? void 0 : (_node$data4$target$fi4 = _node$data4$target$fi3.file) === null || _node$data4$target$fi4 === void 0 ? void 0 : _node$data4$target$fi4.url,
        assetUrl: node === null || node === void 0 ? void 0 : (_node$data5 = node.data) === null || _node$data5 === void 0 ? void 0 : (_node$data5$target = _node$data5.target) === null || _node$data5$target === void 0 ? void 0 : (_node$data5$target$fi = _node$data5$target.fields) === null || _node$data5$target$fi === void 0 ? void 0 : _node$data5$target$fi.downloadableAssetUrl,
        customFormIdentifier: node === null || node === void 0 ? void 0 : (_node$data6 = node.data) === null || _node$data6 === void 0 ? void 0 : (_node$data6$target = _node$data6.target) === null || _node$data6$target === void 0 ? void 0 : (_node$data6$target$fi = _node$data6$target.fields) === null || _node$data6$target$fi === void 0 ? void 0 : _node$data6$target$fi.formId
      });
    }
  }), _defineProperty(_renderNode, BLOCKS.QUOTE, function (_, children) {
    return _jsx(Blockquote, {
      children: children
    });
  }), _defineProperty(_renderNode, BLOCKS.HR, function () {
    return _jsx(Divider, {});
  }), _defineProperty(_renderNode, BLOCKS.EMBEDDED_ENTRY, function (node) {
    var blockId = node.data.target.sys.contentType.sys.id;

    if (blockId === "codeBlock") {
      var code = node.data.target.fields.code;
      return _jsx(CodeBlock, {
        variant: "code",
        tag: "pre",
        children: code
      });
    }

    if (blockId === "codeSnippet") {
      var _node$data$target$fie2 = node.data.target.fields,
          _code = _node$data$target$fie2.code,
          language = _node$data$target$fie2.language;
      return _jsx(Highlighter, {
        content: _code,
        language: language
      });
    }

    if (blockId === "basicTable") {
      return _jsx(Table, {
        data: node.data.target.fields
      });
    }

    if (blockId === "video") {
      return _jsx(Video, {
        data: node.data.target.fields
      });
    }

    if (blockId === "embeddedVideo") {
      return _jsx(Video, {
        data: {
          url: node.data.target.fields.embedUrl
        }
      });
    }

    if (blockId === "downloadOnSubmitForm") {
      var _node$data7, _node$data7$target, _node$data7$target$fi, _node$data8, _node$data8$target, _node$data8$target$fi, _node$data9, _node$data9$target, _node$data9$target$fi, _node$data9$target$fi2, _node$data9$target$fi3, _node$data9$target$fi4, _node$data10, _node$data10$target, _node$data10$target$f, _node$data11, _node$data11$target, _node$data11$target$f;

      return _jsx(ContentDownloadForm, {
        heading: node === null || node === void 0 ? void 0 : (_node$data7 = node.data) === null || _node$data7 === void 0 ? void 0 : (_node$data7$target = _node$data7.target) === null || _node$data7$target === void 0 ? void 0 : (_node$data7$target$fi = _node$data7$target.fields) === null || _node$data7$target$fi === void 0 ? void 0 : _node$data7$target$fi.header,
        description: node === null || node === void 0 ? void 0 : (_node$data8 = node.data) === null || _node$data8 === void 0 ? void 0 : (_node$data8$target = _node$data8.target) === null || _node$data8$target === void 0 ? void 0 : (_node$data8$target$fi = _node$data8$target.fields) === null || _node$data8$target$fi === void 0 ? void 0 : _node$data8$target$fi.description,
        image: node === null || node === void 0 ? void 0 : (_node$data9 = node.data) === null || _node$data9 === void 0 ? void 0 : (_node$data9$target = _node$data9.target) === null || _node$data9$target === void 0 ? void 0 : (_node$data9$target$fi = _node$data9$target.fields) === null || _node$data9$target$fi === void 0 ? void 0 : (_node$data9$target$fi2 = _node$data9$target$fi.image) === null || _node$data9$target$fi2 === void 0 ? void 0 : (_node$data9$target$fi3 = _node$data9$target$fi2.fields) === null || _node$data9$target$fi3 === void 0 ? void 0 : (_node$data9$target$fi4 = _node$data9$target$fi3.file) === null || _node$data9$target$fi4 === void 0 ? void 0 : _node$data9$target$fi4.url,
        assetUrl: node === null || node === void 0 ? void 0 : (_node$data10 = node.data) === null || _node$data10 === void 0 ? void 0 : (_node$data10$target = _node$data10.target) === null || _node$data10$target === void 0 ? void 0 : (_node$data10$target$f = _node$data10$target.fields) === null || _node$data10$target$f === void 0 ? void 0 : _node$data10$target$f.downloadableAssetUrl,
        customFormIdentifier: node === null || node === void 0 ? void 0 : (_node$data11 = node.data) === null || _node$data11 === void 0 ? void 0 : (_node$data11$target = _node$data11.target) === null || _node$data11$target === void 0 ? void 0 : (_node$data11$target$f = _node$data11$target.fields) === null || _node$data11$target$f === void 0 ? void 0 : _node$data11$target$f.formId
      });
    }
  }), _renderNode)
};

var RichText = function RichText(_ref) {
  var data = _ref.data,
      options = _ref.options;
  return _jsx(_Fragment, {
    children: documentToReactComponents(data, {
      renderNode: _objectSpread(_objectSpread({}, defaultOptions.renderNode), options === null || options === void 0 ? void 0 : options.renderNode),
      renderMark: _objectSpread(_objectSpread({}, defaultOptions.renderMark), options === null || options === void 0 ? void 0 : options.renderMark),
      renderText: options === null || options === void 0 ? void 0 : options.renderText
    })
  });
};

export default RichText;